export const blockIconsHouseholdGarageNew = (
	<span className='material-symbols-outlined'>garage</span>
);
